import SEO from "@/components/SEO";

export default function About() {
  return (
    <>
      <SEO title="Hakkımızda | Estem Sürücü Kursu Gebze"
        description="37 yıllık deneyim ile Gebze&apos;nin en köklü sürücü kursu. Misyonumuz, vizyonumuz ve ekibimiz."
        canonical="https://www.estemsurucukursu.com/hakkimizda" />
      <section className="px-4 md:px-8 py-12 md:py-20 max-w-7xl mx-auto">
        <div className="nb-badge mb-4">Hakkımızda</div>
        <h1 className="font-heading font-bold text-5xl md:text-7xl tracking-tight leading-[1.05]">
          1989&apos;ten beri <span className="text-brand-primary">Gebze yollarında.</span>
        </h1>
        <div className="grid md:grid-cols-2 gap-12 mt-12 items-start">
          <div className="space-y-6 text-lg leading-relaxed">
            <p>Estem Sürücü Kursu, <strong>37 yılı aşkın süredir</strong> Gebze ve Kocaeli&apos;nde binlerce kişiye ehliyet kazandırdı. Modern eğitim araçlarımız, deneyimli kadromuz ve yenilikçi öğretim yöntemlerimizle her yıl ortalama <strong>800+ kursiyer</strong> mezun ediyoruz.</p>
            <p>Misyonumuz; sadece ehliyet almak değil, <strong>güvenli ve bilinçli sürücüler yetiştirmek.</strong> 2026 itibariyle online kayıt, dijital evrak takibi ve taksitli ödeme sistemimizle eğitim sürecini en hızlı ve kolay hale getirdik.</p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { v: "37+", l: "Yıllık Deneyim", popular: true },
              { v: "33.000+", l: "Mezun Sayısı", popular: false },
              { v: "10", l: "Profesyonel Eğitmen", popular: false },
              { v: "13", l: "Aktif Eğitim Aracı", popular: false },
            ].map((s,i)=>(
              <div key={i} className={`nb-card p-6${s.popular ? " !bg-brand-primary text-white" : " bg-white"}`}>
                <div className="font-heading font-bold text-5xl tracking-tighter">{s.v}</div>
                <div className={`mt-2 text-[11px] font-semibold tracking-[0.12em] uppercase${s.popular ? " text-white/60" : " text-stone-500"}`}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {[
            { t: "Misyonumuz", d: "Trafikte güvenliği ön planda tutan, kurallara saygılı ve donanımlı sürücüler yetiştirmek." },
            { t: "Vizyonumuz", d: "Kocaeli'nin teknolojiyi en iyi kullanan, kursiyer memnuniyeti en yüksek sürücü kursu olmak." },
            { t: "Değerlerimiz", d: "Şeffaflık, güven, yenilikçilik ve kursiyer odaklı yaklaşım." },
          ].map((v,i)=>(
            <div key={i} className="nb-card p-8">
              <h3 className="font-heading font-bold text-2xl uppercase">{v.t}</h3>
              <p className="mt-3 text-brand-muted">{v.d}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
